export default {
  send: 'Отправить',
  cancel: 'Отмена',
  ok: 'Ok',
  save: 'Сохранить',
  destroy: 'Удалить',
  removal: 'Удаление',
  add: 'Добавить',
  close: 'Закрыть',
  comeOut: 'Выйти',
  warning: 'Предупреждение',
  search: 'Поиск',
  settings: 'Настройки',
  invite: 'Пригласить',
  back: 'Назад',
  empty: 'Пусто',
  edit: 'Редактировать',
  show: 'Показать',
  confirm: 'Подтвердить',
  continue: 'Продолжить',
  total: 'Итого',
  subtotal: 'Итого по ',
  nothingFound: 'Ничего не найдено',
  noData: 'Нет данных',
  complete: 'Завершить',
  report: 'Отчёт',
  move: 'Перейти',
  time: 'Время',
  cut: 'Вырезать',
  update: 'Обновить',
  error: 'Ошибка',
  selectLang: 'Выберите язык',
  select: 'Выбрать',
  noAccess: 'У вас нет доступа к ресурсу.',
  resourceNotAvailable: '404 - Ресурс не существует.',
  youWantRemove: 'Вы действительно хотите удалить ',
  enterSearch: 'Начните вводить название для поиска',
  saveInExcel: 'Сохранить в Excel',
  downloadExcel: 'Загрузить Excel',
  saveAndDownload: 'Сохранить и скачать',
  yes: 'Да',
  no: 'Нет',
  dialog: {
    fullscreen: 'Полноэкранный режим',
    exitFullscreen: 'Выйти из полноэкранного режима',
    inFullscreen: 'Во весь экран',
  },
  login: {
    entry: 'Вход',
    loginOrEmail: 'Логин или email',
    enterLoginOrEmail: 'Введите логин или email',
    password: 'Пароль',
    enterPassword: 'Введите пароль',
    resetPassword: 'Восстановить пароль',
    enter: 'Войти',
    userNotFound: 'Пользователь не найден',
    sentLetter: 'На Ваш email отправлено письмо',
    incorrectLoginOrPassword: 'Неправильный логин или пароль',
  },
  registry: {
    name: 'Имя',
    enterName: 'Введите Ваше имя',
    login: 'Логин',
    enterLogin: 'Введите Ваш логин',
    farmName: 'Название хозяйства',
    enterFarmName: 'Введите название хозяйства',
    email: 'Email',
    enterEmail: 'Введите Ваш Email',
    innFarm: 'ИНН хозяйства',
    enterInnFarm: 'Введите ИНН хозяйства',
    createPassword: 'Придумайте пароль',
    confirmPassword: 'Подтвердите пароль',
    code: 'Код',
    phone: 'Телефон',
    enterPhone: 'Введите телефон',
  },
  personalAccount: {
    title: 'Личный кабинет',
    wantQuit: 'Вы точно хотите выйти?',
    fullName: 'ФИО',
    changePassword: 'Изменить пароль',
  },
  changePassword: {
    repeatPassword: 'Повторите пароль',
    enterSamePassword: 'Введите одинаковые пароли',
    newPassword: 'Новый пароль',
    changedPassword: 'Ваш пароль изменён. Перейдите на страницу авторизации.',
  },
  organizations: {
    title: 'Организации',
    organization: 'Организация',
    currentOrganization: 'Текущая организация',
    nameOrganization: 'Наименование организации',
    settingOrganization: 'Настройки организации',
    typeOrganization: 'Тип организации',
    inn: 'ИНН',
    changeOrganization: 'Поменять орагнизацию',
    selectOrganization: 'Выбрать организацию',
    addOrganization: 'Добавить организацию',
    newOrganization: 'Новая организация',
    farm: 'Хозяйство',
  },
  fields: {
    title: 'Поля',
    field: 'Поле',
    myFields: 'Мои поля',
    listFields: 'Список полей',
    addField: 'Добавить поле',
    newField: 'Новое поле',
    deleteField: 'Удалить поле',
    deletePolygon: 'Удалить полигон',
    addPolygon: 'Добавить полигон',
    area: 'Площадь: ',
    areaField: 'Площадь поля: ',
    hectare: 'Га',
    averageHectare: 'Средняя на гектар: ',
    editingField: 'Редактирование поля',
    editField: 'Редактировать поле',
    enterAddressYourField: 'Введите адрес вашего поля или щелкните на карте',
    enterRegion: 'Введите регион',
    enterDistrict: 'Введите район',
    soilType: 'Тип почвы',
    nameField: 'Название поля',
    enterNameField: 'Введите название поля',
    selectCategory: 'Выберите категорию',
    areaYourField: 'Площадь вашего поля (Га)',
    autoArea: 'Автоплощадь',
    maxSizeField: 'Макс. размер поля',
    pairs: 'Пар',
    grade: 'Сорт',
    feedMix: 'Кормосмесь',
    confirmSowing: 'Подтвердить сев',
    sowing: 'Сев',
    dateSowing: 'Дата сева',
    volumeSowing: 'Объём сева',
    noCropData: 'Нет данных о севе',
    unitMeasure: 'Ед.изм.',
    volumeHarvest: 'Объем урожая',
    cleaningDate: 'Дата уборки',
    collection: 'Сбор',
    amountCollected: 'Объем сбора',
    basicInformation: 'Основная ифнормация',
    stageGrowth: 'Стадия роста:',
    numberField: 'Поле №',
    shouldNotCross: 'Поля не должны пересекаться',
    overlapNotAllowed: 'Самопересечение полей недопустимо',
  },
  cycle: {
    title: 'Цикл',
    newCycle: 'Новый цикл',
    addCycle: 'Добавить цикл',
    removeCycle: 'Удалить цикл',
    currentCycle: 'Текущий цикл',
    changeCycle: 'Изменить цикл',
    editCycle: 'Редактировать цикл',
    cropAndGrade: 'Культура и сорт',
    pairView: 'Вид пара',
    cleaning: 'Уборка',
    confirmCleaning: 'Подтвердить уборку',
    volumeCleaning: 'Объем уборку',
    scheduledCollection: 'Запланирован сбор урожая:',
    harvest: 'Сбор урожая: ',
    notPlanned: 'Не запланирован',
    informationMissing: 'Информация о текущем цикле отсутствует',
    predecessor: 'Предшественник',
    noInformationPredecessor: 'Информация о предшественнике отсутствует',
  },
  region: {
    noDataGraphic: 'Нет данных для построения графиков',
  },
  weather: {
    title: 'Прогноз погоды',
    weather: 'Погода',
    humidity: 'Влажность',
    wind: 'Ветер',
    temperature: 'Температура',
    precipitation: 'Осадки',
    sumPrecipitations: 'Сумма осадков',
    directionWind: 'Направление ветра',
    dewTemperature: 'Температура точки росы',
    atmosphericPressure: 'Атмосферное давление',
    airAndPrecipitation: 'Воздух и осадки',
    errorWeather: 'Ошибка в загрузке прогноза погоды!',
    weatherForField: 'Прогноз погоды для «Поле ',
    pressure: 'Давление',
    windGusts: 'Порывы ветра',
    short: {
      airTemperature: 'Темп. воздуха',
      dewTemperature: 'Темп. точки росы',
      rainfall: 'К-во осадков',
      directionWind: 'Напр. ветра',
      windSpeed: 'Скор. ветра',
    },
  },
  analysis: {
    title: 'Анализ',
    addAnalysis: 'Добавить анализ',
    listAnalysis: 'Список анализов',
    analysisCollection: 'Сбор анализов',
    emptyAnalysis: 'Анализы отсутствуют',
    gridFormation: 'Формирование сетки',
    secureNet: 'Закрепить сетку',
    routeMapping: 'Отрисовка маршрута',
    enterData: 'Ввод данных',
    customer: 'ООО «КлеверFarmer»',
    analysisField: 'Анализ поля',
    saveData: 'Сохранение данных',
    sectionNumberOne: 'Номер первого участка',
    downloadData: 'Загрузка данных',
    startCollecting: 'Начать сбор',
    workDate: 'Дата проведения работы',
    clearAnalysisTable: 'Очистить таблицу с данными анализов?',
    collectingSamples: 'Кол-во проб для отбора: ',
    collectAnalyses: 'Собрать анализы',
    routeAnalysisCollector: 'Показать маршрут сборщика анализов',
    statusAnalysisCollection: 'Статус сбора анализов',
    analysisTable: 'Таблица анализов',
    dateAnalysis: 'Дата сбора анализов:',
    analysisCollectionDateNotAvailable: 'Дата сбора анализов отсутствует!',
    fileGeneration: 'Продолжить формировать файл?',
    displayed: 'Отображаемый показатель',
    dateCollection: 'Дата сбора: ',
  },
  tableAssay: {
    basicAttributes: 'Базовые атрибуты',
    additionalAttributes: 'Дополнительные атрибуты',
    numberEU: '№ ЭУ п/п',
    numberSample: 'Номер образца',
    average: 'Среднее',
  },
  laboratory: {
    title: 'Лаборатория',
    definitionForm: 'Форма \nопред.',
    indicatorsAndMethodologies: 'Агрохимические показатели и методики',
    dischargeForm: 'Форма выгрузки-загрузки',
    testProtocol: 'ПРОТОКОЛ ИСПЫТАНИЙ №',
    from: 'от',
    nameCustomer: 'Наименование и адрес заказчика:',
    farmName: 'Наименование хозяйства:',
    sampleName: 'Наименование объекта исследования (пробы):',
    soil: 'почва',
    selectLaboratory: 'Выберите лабораторию',
    transferSample: 'Отбор и транспортировка пробы:',
    dateReceipt: 'Дата поступления объекта (пробы):',
    testDate: 'Дата проведения испытаний:',
    settingsAttributes: 'Настройка атрибутов для excel файла',
    excelAttributes: 'Атрибуты excel-файла',
  },
  workLog: {
    title: 'Журнал работ',
    addWork: 'Добавить работу',
    date: 'Дата',
    work: 'Работа',
    volume: 'Объем',
    deleteWork: 'Удалить работу?',
    typeWorks: 'Вид работ',
    dateWork: 'Дата проведения работы',
    newWork: 'Новая работа',
  },
  satelliteMonitoring: {
    title: 'Спутниковый мониторинг',
    areaLimit: 'Превышен лимит площади',
    connectSatellites: 'Подключить спутники',
    from: ' из ',
    dataProcessing: {
      first: 'Идет обработка спутниковых данных.',
      second: 'Это может занять некоторое время',
    },
  },
  inspections: {
    title: 'Осмотры',
    addTask: 'Добавить задание на осмотр',
    addResult: 'Добавить результат осмотра',
    completedInspection: 'Выполненный осмотр',
    changeInspection: 'Изменить осмотр',
    inspected: 'Осмотр проведен',
    inspect: 'Провести осмотр',
    resultInspection: 'Результат осмотра',
    fieldInspection: 'Осмотры поля',
    planned: 'Запланированные',
    completed: 'Выполненные',
    scheduledInspection: 'Запланированный осмотр',
    changeView: 'Изменить осмотр',
    reviewTask: 'Задание к осмотру',
    inspectionAssignment: 'Задание на осмотр',
    executor: 'Исполнитель',
    priority: 'Приоритет',
    inspectionTime: 'Срок выполнения осмотра',
    inspectionDate: 'Дата проведения осмотра',
    inspectionReport: 'Отчет о выполнении осмотра',
    reviewPhoto: 'Фото осмотра',
    growthStage: 'Подстадии роста',
    currentStage: 'Текущая стадия',
    stageNotDefined: 'Стадия не определена',
  },
  incidents: {
    title: 'Инциденты',
    addIncident: 'Добавить инцидент',
    character: 'Характер инцидента',
    description: 'Описание инцидента',
    photo: 'Фото инцидента',
    delete: 'Удалить инцидент',
  },
  history: {
    title: 'История',
    historyFields: 'История поля',
  },
  location: {
    title: 'Местоположение',
    locationSearch: 'Поиск местоположения',
    address: 'Адрес',
    coordinates: 'Координаты',
    position: 'Текущее положение',
    nearestTowns: 'Адрес ближайшего Н.П.',
    width: 'Широта',
    length: 'Долгота',
    enterWidth: 'Введите широту',
    enterLength: 'Введите долготу',
    yourLocation: 'Ваше местоположение',
    geolocationNotAvailable: 'Геолокация недоступна!',
  },
  groups: {
    withoutGroup: 'Без группы',
    newGroup: 'Новая группа',
    nameNewGroup: 'Название новой группы',
    selectGroup: 'Выберите группу',
    removeGroup: 'Удалить группу',
    massControl: 'Массовое управление',
    removeFieldsGroup: 'Удалить поля из группы?',
    createGroup: 'Создать группу',
    moveGroup: 'Переместить в группу',
    removeFromGroup: 'Убрать из группы',
    selectedFieldsMoveGroup: 'После создания все выделенные поля переместятся туда',
  },
  sorting: {
    filterAndSorting: 'Фильтр и сортировка',
    byDate: 'По дате',
    alphabetically: 'По алфавиту',
    square: 'По площади',
    selectCulture: 'Выберите культуру',
    byIncrement: 'по возврастанию',
    byDecreasing: 'по убыванию',
    byAgroChemicalAnalysis: 'По агрохим анализу',
    collectionStatus: 'Статус сбора',
    finished: 'Завершён',
  },
  reportTypes: {
    reports: 'Отчёты',
    cropsReport: 'Посевы (отчёт)',
    cropsChart: 'Посевы (диаграмма)',
    fieldsReport: 'Поля (отчёт)',
    fieldAnalysisReport: 'Отчет анализов полей',
    addReport: 'Добавить отчет',
    yourself: 'Себе',
    reportOffice: 'Отчет Управления',
    uship: 'УСХиП',
    mship: 'МСХиП',
  },
  meteoStations: {
    title: 'Метеостанции',
    newStation: 'Новая станция',
    myStations: 'Мои станции',
    addStation: 'Добавить станцию',
    stationCapacityAssessment: 'Оценка работоспособности метеостанций',
    evaluationPeriod: 'Период оценки',
    graphic: 'График',
    editStation: 'Редактировать станцию',
    editingStation: 'Редактирование станции',
    measured: 'Измерено:',
    uvIndex: 'UV Индекс',
    lighting: 'Освещенность',
    lux: 'Люкс',
    sumTemperatures: 'Сумма активных температур',
    sumTemperaturesPeriod: 'Сумма активных температур (с начала периода)',
    stationsNotLoaded: 'Ошибка. Данные метеостанций не были подгружены!',
    days: 'суток',
    sum: 'Сумма, мм',
    precipitationAmount: 'Сумма осадков',
    dailyPrecipitation: 'Осадки за сутки',
    oneDay: '1 сутки',
    withGustsUp: 'с порывами до',
    precipitation: 'Осадки, мм',
    height: 'Высота',
    timeZone: 'Часовой пояс',
    model: 'Модель метеостанции',
    surveyMethod: 'Способ опроса',
    modules: 'Модули метеостанции',
    ip: 'IP Адрес/Host',
    port: 'Порт',
    id: 'Уникальный идентификатор станции',
    topic: 'Топик для получения данных',
    addSensor: 'Добавить датчик',
    measurementHorizonsTemperature: 'Горизонты измерения температуры почвы',
    measurementHorizonsHumidity: 'Горизонты измерения влажности почвы',
    observationArchive: 'Архив наблюдений',
    collectedData: 'Накопленные данные',
    noDataAvailable: 'Данные для сохранения отсутствуют',
    collected: 'Накопленные',
    dailyRates: 'Суточные',
    station: 'Нак.Метеостанция_',
    indexAndIllumination: 'UV Индекс и Освещенность',
    date: 'Дата/Время',
    stationArchive: 'Арх.Метеостанция',
    requests: 'Запросов',
  },
  areas: {
    title: 'Районы',
    area: 'Район',
    nameArea: 'Наименование района',
    myAreas: 'Мои районы',
    localities: 'Населённые пункты',
    region: 'Регион',
    districtAdministration: 'Администрация района',
    regionalAdministration: 'Администрация региона',
    couldNotDetermine: 'Регион не удалось определить! Выберите самостоятельно!',
  },
  directories: {
    title: 'Справочники',
    workManual: 'Справочник работ',
    machineryAndEquipment: 'Машины и агрегаты',
    typeWork: 'Вид работ',
    measurementUnit: 'Единица измерения',
    attributes: 'Атрибуты',
  },
  attributes: {
    attributeRemoval: 'Удаление атрибутов',
    wantRemoveAttributes: 'Вы действительно хотите удалить все атрибуты?',
    jobAttributes: 'Атрибуты Работ',
    typeWork: 'Тип работ',
    title: 'Заголовок',
    enterTitle: 'Введите заголовок',
    listItemHeader: 'Заголовок элемента списка',
    addListItem: 'Добавить элемент списка',
    addAttribute: 'Добавить атрибут',
    settingAttributes: 'Настройка атрибутов',
  },
  machineryAndEquipment: {
    name: 'Название',
    number: 'ГРЗ (гос номер)',
    type: 'Тип техники',
  },
  agroChemicalExamination: {
    title: 'АгроХимОбследование',
  },
  act: {
    actNumber: 'Акт № ',
    removalAct: 'Удаление акта',
    wantDeleteAct: 'Вы действительно хотите удалить акт?',
    selectionAct: 'Акт отбора',
    annexAct: 'Приложение к акту отбора',
    sampleTags: 'Бирки проб',
    next: 'Далее',
    sendingLaboratory: 'Отправка в лабораторию',
    sendLaboratory: 'Отправить в лабораторию',
    documents: 'Документы:',
    listDocuments: 'Список документов',
    readyDocuments: 'Готовые документы',
    downloadReadyDocuments: 'Скачайте готовы документы и отправьте их в лабораторию',
    dataSelectionAct: 'Заполните данные для формирования акта отбора',
    testData: 'Данные об испытании',
    actSelectionNumber: 'Номер акта отбора',
    testDate: 'Дата проведения испытания',
    pickerName: 'ФИО Отборщика',
    namePresent: 'ФИО присутствующего',
    nameCustomer: 'ФИО Заказчика',
    testLayer: 'Исследуемый слой почвы, см',
    sampleSendingData: 'Заполните данные для отправки образцов в лабораторию',
  },
  map: {
    title: 'Карта',
    maps: 'Карты',
    yandexMaps: 'Яндекс карты',
    googleMaps: 'Google карты',
    selectCard: 'Выберите тип карты',
    regionalOffice: 'Росреестр',
    undoChanges: 'Отменить изменения',
    gridType: 'Тип сетки',
    gridArea: 'Площадь сетки: ',
    tiltAngle: 'Угол наклона: ',
    scale: 'Масштаб: ',
    changePoint: 'Изменить расположение точек',
    combinePlots: 'Объединить участки',
    changeNumberPlot: 'Изменить номер участка',
    numberPlot: 'Номер элементарного участка',
    removePlot: 'Удалить участок',
    cancelStep: 'Отменить шаг',
    clearRoute: 'Очистить от маршрута',
    positioning: 'Определение местоположения',
    cancelPosition: 'Отменить позицию',
    startingNew: 'Начать новый',
    fixedPosition: 'Зафиксировать позицию',
    saveMap: 'Сохранить карту для печати',
    addDot: 'Добавить точку',
    pointChosen: 'Одна из точек линии уже была выбрана!',
    simplifyContour: 'Упростить контур',
    accuracy: 'Точность',
    plots: 'участк(a/ов)',
    route: 'Маршрут',
    matrix: 'Матрица',
    curtain: 'Шторка',
    notifications: {
      deviceNotNavigation: 'Ошибка! На устройстве отсутсвует навигация',
      waitLocation: 'Дождитесь определения местоположения!',
      collectionAnalysis: 'На поле проводился сбор анализов!',
      alreadyCollectionAnalysis: 'На полигоне уже был сбор анализов!',
      polygonNotFound: 'Полигон на текущей позиции небыл найден!',
      dotInField: 'Ошибка! Поставьте точку в пределах поля!',
      locationOnMap: 'Поставьте место на карте для осмотра!',
      placeOnMap: 'Поставьте место на карте!',
    },
  },
  baseValidation: {
    requiredField: 'Обязательное поле',
    incorrectEmail: 'Введите корректный E-mail',
    passwordsDontMatch: 'Введённые пароли не совпадают',
    minCharacters: {
      start: 'Минимально',
      end: 'символов',
    },
    maxCharacters: {
      start: 'Максимально',
      end: 'символов',
    },
    minValue: 'Минимальное значение ',
    maxValue: 'Максимальное значение ',
    numberValue: 'Значение должно быть числом',
  },
  satellite: {
    title: 'Спутник',
    imageDate: 'Дата снимка',
    cloud: 'Облачность',
    representation: 'Представление',
    applyAllFields: 'Применить ко всем полям',
    layer: 'Слой',
    fieldChronology: 'Хронология поля',
  },
  agroChemicalAnalysis: {
    title: 'Агрохим анализ',
    fieldAverage: 'Среднее по полю',
    indicator: 'Показатель',
    interpolation: 'Интерполяция',
    noAnalysis: 'Нет анализа',
    notStarted: 'Не начат',
    inProcess: 'В процессе',
    finished: 'Закончен',
    completed: 'Завершен',
  },
  cabinetFarms: {
    title: 'Кабинет хозяйства',
    nameFarms: 'Наименования хозяйств',
    organizationProfile: 'Профиль организации',
  },
  users: {
    title: 'Пользователи',
    user: 'Пользователь',
    newUser: 'Новый пользователь',
    superManager: 'Суперадминистратор',
    inviteUsers: 'Пригласить пользователя',
    name: 'Имя',
    removalUser: 'Удаление пользователя',
    wantDeleteUser: 'Вы действительно хотите удалить пользователя?',
    roles: 'Роли',
    notChangeRoles: 'Вы не можете изменить свои роли',
    invitationSent: 'Приглашение отправлено',
  },
  managementReport: {
    title: 'Отчет хозяйства',
    nameFarm: 'Наименование хозяйства',
    culture: 'Культура',
    area: 'Площадь, Га',
  },
  fieldAnalysisReport: {
    yearsAnalysis: 'Год анализов',
    requestReport: 'Запросить отчет',
    moreInformation: 'Дополнительная информация',
    typesDryLand: 'Виды с/x угодий',
    data: {
      title: 'Данные на',
      yearMissing: 'год отсутствуют!',
    },
    intro: 'Введение',
    conclusion: 'Вывод',
    file: {
      start: 'Отчет анализов полей за',
      end: 'год.zip',
    },
  },
  tableStatuses: {
    veryLow: 'Очень низкий',
    low: 'Низкий',
    normal: 'Нормальный',
    average: 'Средний',
    high: 'Высокий',
    veryHigh: 'Очень высокий',
  },
  spectrogramIndicators: {
    veryLow: 'Очень низкое',
    low: 'Низкое',
    average: 'Среднее',
    high: 'Повышенное',
    veryHigh: 'Высокое',
  },
  cropDistribution: {
    title: 'Распределение посевов по культурам и сортам',
    withoutGrade: 'Без сорта',
    noDataForChart: 'Нет данных для построения графика',
  },
  tasks: {
    title: 'Задания',
    tasksAndReports: 'Задания и отчёты',
  },
  datePicker: {
    incorrectDate: 'Дата введена некорректно',
    sequenceBroken: 'Последовательность дней нарушена',
    rangeDate: 'Диапазон дат',
  },
  layerTypes: {
    notShow: 'Не показывать',
    naturalColor: 'Натуральный цвет',
  },
  presentationTypes: {
    index: 'Индекс',
    homogeneity: 'Однородность',
    dynamics: 'Динамика',
  },
  dangerousPhenomena: {
    title: 'Опасные явления',
    check: 'Проверить',
    date: 'Дата',
    type: 'Тип',
    dataMissing: 'Данные отстутсвуют',
    selectPeriodAndType: 'Выберите период и тип опасных явлений',
  },
  indicators: {
    n: 'Азот (N)',
    p: 'Фосфор (Р)',
    k: 'Калий (К)',
    s: 'Сера (S)',
    ph: 'рН',
    humus: 'Гумус',
    salinization: 'Засоление',
    ca: 'Кальций (Ca)',
    mg: 'Магний (Mg)',
    fe: 'Железо (Fe)',
    mn: 'Марганец (Mn)',
    zn: 'Цинк (Zn)',
    cu: 'Медь (Cu)',
    b: 'Бор (B)',
    mo: 'Молибден (Mo)',
    na: 'Натрий (Na)',
    cl: 'Хлор (Cl)',
    co: 'Кобальт (Co)',
    soilCompaction: 'Уплотненность почвы',
    salinizationType: 'Тип Засоления',
  },
  optionsIndicators: {
    'Стандартный метод': 'Стандартный метод',
    'по Тюрину и Коноваловой': 'по Тюрину и Коноваловой',
    'по Корнфилду': 'по Корнфилду',
    'по Кравкову': 'по Кравкову',
    'по Мачигину': 'по Мачигину',
    'по Кирсанову': 'по Кирсанову',
    'по Чирикову': 'по Чирикову',
    'по Эгнеру Римму': 'по Эгнеру Римму',
    'по Маслову': 'по Маслову',
    Сульфатное: 'Сульфатное',
    Хлоридное: 'Хлоридное',
    'Сульфатно-хлоридное': 'Сульфатно-хлоридное',
    'Хлоридно-сульфатное': 'Хлоридно-сульфатное',
    'Содово-хлоридный': 'Содово-хлоридный',
    'Содово-сульфатный': 'Содово-сульфатный',
    'Хлоридно-содовый': 'Хлоридно-содовый',
    'Сульфатно-содовый': 'Сульфатно-содовый',
    'Сульфатно-хлоридный гидрокарбонатный':
      'Сульфатно-хлоридный гидрокарбонатный',
    Карбонатное: 'Карбонатное',
  },
  suffixes: {
    massFraction: 'мг/кг',
    density: 'г/см³',
    pressure: 'кг/см2',
    percent: '%',
    degree: '°C',
    millimetre: 'мм',
    metersPerSecond: 'м/c',
    degreeAngle: '°',
    atmosphericPressure: 'мм рт. ст.',
    precipitation: 'мм/ч',
    centimeter: 'см',
  },
  labelsAttributeType: {
    string: 'Текст',
    text: 'Многострочный текст',
    flag: 'Флаг',
    list: 'Список',
  },
  machineryTypeLabel: {
    selfPropelled: 'Cамоходный',
    trailer: 'Прицеп',
  },
  fieldsCategories: {
    cropland: 'Пашня',
    hayfield: 'Сенокос',
    permanentCrops: 'Многолетние насаждения',
    pasture: 'Пастбище',
    fallowLand: 'Залеж',
  },
  saveInImage: {
    inJpeg: 'Сохранить в JPEG',
    inPng: 'Сохранить в PNG',
    inSvg: 'Сохранить в SVG',
  },
  textUnits: {
    tn: 'т',
    cwt: 'ц',
    kg: 'кг',
    num: 'шт',
    su: 'cwt',
    suha: 'пос.ед',
    tnha: 'т/га',
    cwtha: 'ц/га',
    kgha: 'кг/га',
    numha: 'шт./га',
  },
  textFallows: {
    clear: 'Чистый',
    occupied: 'Занятый',
    half: 'Полупар',
    sideral: 'Сидеральный',
  },
  assayType: {
    gost: 'ГОСТ',
    bionic: 'Бионическое',
  },
  roteLabel: {
    auto: 'Автоматический',
    hand: 'Ручной',
  },
  errorsPolygon: {
    selectPointPolygon: 'Выберите полигон, в котором есть точка!',
    selectActivePolygon: 'Выберите активный полигон!',
    notMatchNumber: 'Ошибка импорта файла! Импортированное количество полигонов не соответствует текущему!',
    checkPolygonsMatch: 'Ошибка импорта файла! Проверьте соответствие полигонов!',
    errorSelectRoute: 'Ошибка! Выберите маршрут!',
    errorRequiredFields: 'Ошибка! Заполните необходимые поля!',
    typeImportError: 'Ошибка импорта типов! Проверьте тип',
    initializationError: 'Ошибка инициализации!',
  },
  seriesTypes: {
    calm: 'Штиль',
    lightWind: 'Легкий ветер',
    lightBreeze: 'Легкий бриз',
    weakWind: 'Слабый ветер',
    moderateWind: 'Умеренный ветер',
    freshBreeze: 'Свежий бриз',
    nearStorm: 'Близкий шторм',
    storm: 'Шторм',
    strongWind: 'Сильный ветер',
    fierceStorm: 'Свирепый шторм',
    hurricane: 'Ураган',
  },
  highcharts: {
    loading: 'Загрузка...',
    months: {
      January: 'Январь',
      February: 'Февраль',
      March: 'Март',
      April: 'Апрель',
      May: 'Май',
      June: 'Июнь',
      July: 'Июль',
      August: 'Август',
      September: 'Сентябрь',
      October: 'Октябрь',
      November: 'Ноябрь',
      December: 'Декабрь',
    },
    weekdays: {
      Sunday: 'Воскресенье',
      Monday: 'Понедельник',
      Tuesday: 'Вторник',
      Wednesday: 'Среда',
      Thursday: 'Четверг',
      Friday: 'Пятница',
      Saturday: 'Суббота',
    },
    shortMonths: {
      January: 'Янв',
      February: 'Фев',
      March: 'Март',
      April: 'Апр',
      May: 'Май',
      June: 'Июнь',
      July: 'Июль',
      August: 'Авг',
      September: 'Сент',
      October: 'Окт',
      November: 'Нояб',
      December: 'Дек',
    },
    rangeSelectorFrom: 'С',
    rangeSelectorTo: 'По',
    rangeSelectorZoom: 'Период',
    downloadPNG: 'Скачать PNG',
    downloadJPEG: 'Скачать JPEG',
    downloadPDF: 'Скачать PDF',
    downloadSVG: 'Скачать SVG',
    printChart: 'Напечатать график',
    resetZoom: 'Cбросить Zoom',
    viewFullscreen: 'Полноэкранный режим',
    exitFullscreen: 'Обычный режим',
    errorSaveFile: 'Ошибка при сохранении файла',
  },
  timezone: {
    utc2: 'UTC+2, Калининград',
    utc3: 'UTC+3, Москва',
    utc4: 'UTC+4, Астрахань',
    utc5: 'UTC+5, Екатерингбург',
    utc6: 'UTC+6, Омск',
    utc7: 'UTC+7, Красноярск',
    utc8: 'UTC+8, Иркутск',
    utc9: 'UTC+9, Якутск',
    utc10: 'UTC+10, Владивосток',
    utc11: 'UTC+11, Магадан',
  },
  dangerousPhenomenaTypes: {
    dryWind: 'Суховей',
    atmosphericDrought: 'Засуха атмосферная',
    frost: 'Заморозки',
    heavyDownpour: 'Сильный ливень',
    heavyRain: 'Сильный дождь',
  },
  incidentTypes: {
    disease: 'Заболевание',
    pest: 'Вредители и паразиты',
    technological: 'Технологическая ошибка',
    flooding: 'Подтопление',
    lodging: 'Полегание',
    weed: 'Сорняки',
    other: 'Прочее',
  },
  router: {
    error403: 'Ошибка 403',
    main: 'КлеверFarmer',
    districts: 'Районы',
    organizations: 'Организации',
    fields: 'Поля и посевы',
    agroSurvey: 'АгроХимОбследование',
    worksManual: 'Справочник работ',
    machines: 'Машины и агрегаты',
    constructionLog: 'Журнал работ',
    fieldHistory: 'История поля',
    satellite: 'Спутниковые данные',
    scouting: 'Осмотры полей',
    meteos: 'Метеостанции',
    stationPerformance: 'Оценка работоспособности станций',
    organizationProfile: 'Профиль организации',
    cropStructure: 'Структура посевов',
    speciesTable: 'Структура посевов/табличный вывод',
    fieldsTable: 'Список полей/табличный вывод',
    fieldsAnalysisReport: 'Отчет анализов полей',
    login: 'Вход',
    restorePassword: 'Восстановление пароля',
    invite: 'Приглашение',
    error404: 'Ошибка 404',
  },
  httpErrors: {
    noAccess: 'Доступ к серверу отсутствует.',
    accessDenied: 'Ошибка 403: Доступ запрещен.',
    error404: 'Ошибка 404',
    fieldFillingError: 'Ошибка заполнения полей!',
    manyRequests: 'Ошибка 429: Слишком много запросов.',
    unexpectedErrorOccurred: 'Произошла непредвиденная ошибка! Обратитесь к администратору!',
    defaultError: 'Произошла непредвиденная ошибка!',
  },
};
